import {
    Box,
    Button,
    Flex,
    Input,
    Menu,
    MenuButton,
    MenuItemOption,
    MenuList,
    MenuOptionGroup,
    Table,
    TableContainer,
    Tbody,
    Text,
    Th,
    Thead,
    Tr
} from '@chakra-ui/react'
import dayjs from 'dayjs'
import { useState } from 'react'
import Clean from '../../../../components/Clean'
import Pagination from '../../../../components/Pagination'
import { useGet } from '../../../../hooks/useHttp'
import DownloadExcel from './DownloadExcel'
import TableRow from './TableRow'
import { FindItem } from './types'
import SelectWithLabel from '../../../../components/SelectWithLabel'
import Warehouse from '../../../../models/warehouse'
import useDebounce from 'hooks/useDebounce'
import ChevronDown from 'components/Icon/ChevronDown'
import ContainerSelect from 'components/SelectWithLabel/ContainerSelect'

export default function SectionKardex() {
    const [search, setSearch] = useState('')
    const [startDate] = useState(() => dayjs().set('D', 1).format('YYYY-MM-DD'))
    const [endDate] = useState(() => {
        const date = new Date()
        date.setDate(24) //seteamos a 24 en caso la fecha el día sea 31 y evitar que la fecha final sea un mes mas
        date.setMonth(date.getMonth() + 1)
        date.setDate(0)
        return dayjs(date).format('YYYY-MM-DD')
    })
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [warehouse_id, setWarehouseId] = useState<string>('')
    const [category_ids, setCategoryIds] = useState<string[]>([])

    const debounceSearch = useDebounce<string>(
        `/api/inventory_production_items?limit=${limit}&page=${page}&search=${search}${
            warehouse_id ? `&warehouse_id=${warehouse_id}` : ''
        }&category_ids=${category_ids.join(',')}`,
        300
    )

    const { data, reload } = useGet<FindItem[]>(debounceSearch, [])

    const { data: dataWarehouse } = useGet<Warehouse[]>(
        '2>/api/warehouses?limit=0&page=1&order=asc&sort=name&search=',
        []
    )

    const { data: dataCategories } = useGet<Warehouse[]>(
        '3>/api/production_item_categories?limit=0&page=1&order=asc&sort=name&search=',
        []
    )

    function categoriesHandler(value: string | string[]) {
        if (typeof value === 'string') return
        setCategoryIds(value)
    }

    return (
        <Box mt={4}>
            <Box mb={4}>
                <Box>
                    <Clean value={search} onClick={() => setSearch('')}>
                        <Input
                            w={{
                                base: 'full',
                                md: '380px'
                            }}
                            placeholder="🏸 Buscar por nombre de artículo"
                            value={search}
                            onChange={ev => setSearch(ev.target.value)}
                        />
                    </Clean>
                    <Box
                        mt={'2'}
                        display={'flex'}
                        gap={2}
                        flexDir={{
                            base: 'column',
                            md: 'row'
                        }}
                        justifyContent={'end'}
                    >
                        <Box>
                            <Text
                                display={{
                                    base: 'block',
                                    md: 'none'
                                }}
                                fontSize={'sm'}
                                fontWeight={'semibold'}
                            >
                                Seleccionar almacén
                            </Text>
                            <SelectWithLabel
                                onChange={e => {
                                    setWarehouseId(e.target.value ?? '')
                                }}
                                label="Seleccionar almacén"
                                labelFontSize={'xs'}
                                placeholder="Todos"
                            >
                                {dataWarehouse.result.map(d => (
                                    <option key={d.id} value={d.id}>
                                        {d.name}
                                    </option>
                                ))}
                            </SelectWithLabel>
                        </Box>
                        <Box>
                            <Text
                                display={{
                                    base: 'block',
                                    md: 'none'
                                }}
                                fontSize={'sm'}
                                fontWeight={'semibold'}
                            >
                                Seleccionar categorías
                            </Text>
                            <ContainerSelect label="Seleccionar categorías">
                                <Menu closeOnSelect={false} autoSelect={false}>
                                    <MenuButton
                                        as={Button}
                                        rightIcon={
                                            <ChevronDown fill="gray.200" />
                                        }
                                        fontWeight={'bold'}
                                        _focus={{}}
                                        bg={'base-4'}
                                        borderRadius="full"
                                        overflow={'hidden'}
                                        textAlign="left"
                                        w={{ base: 'full', md: 'auto' }}
                                    >
                                        {category_ids.length > 0
                                            ? `${category_ids.length} Sel.`
                                            : `Todos`}
                                    </MenuButton>
                                    <MenuList>
                                        <MenuOptionGroup
                                            type="checkbox"
                                            value={category_ids}
                                            onChange={categoriesHandler}
                                        >
                                            {dataCategories.result.map(d => (
                                                <MenuItemOption
                                                    key={d.id}
                                                    value={d.id.toString()}
                                                >
                                                    {d.name}
                                                </MenuItemOption>
                                            ))}
                                        </MenuOptionGroup>
                                    </MenuList>
                                </Menu>
                            </ContainerSelect>
                        </Box>
                        <Flex gap={2} flexDir={['column', 'column', 'row']}>
                            <DownloadExcel
                                startDate={dayjs
                                    .tz(startDate + ' 00:00:00', 'America/Lima')
                                    .toISOString()}
                                endDate={dayjs
                                    .tz(endDate + ' 23:59:59', 'America/Lima')
                                    .toISOString()}
                                warehouse_id={warehouse_id}
                                category_ids={category_ids}
                            />
                        </Flex>
                    </Box>
                </Box>
            </Box>
            <TableContainer>
                <Table size="md" className="table-a-la-orden">
                    <Thead>
                        <Tr>
                            <Th textAlign="center">Artículo</Th>
                            <Th textAlign="center">Almacén</Th>
                            <Th textAlign="center">Stock</Th>
                            <Th textAlign="center">Unidad de medida</Th>
                            <Th textAlign="center">Costo unitario</Th>
                            <Th textAlign="center">Costo total</Th>
                            <Th textAlign="center">Acciones</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data.result.map(item => (
                            <TableRow
                                reload={reload}
                                key={item.id}
                                item={item}
                                startDate={startDate}
                                endDate={endDate}
                            />
                        ))}
                    </Tbody>
                </Table>
            </TableContainer>
            <Pagination
                limit={limit}
                page={page}
                pages={data.pagination?.pages ?? 0}
                onLimit={setLimit}
                onPage={setPage}
            />
        </Box>
    )
}
